import { useState } from 'react'
import { Alert, App, Card, List, Space, Tag, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { issuesConfig } from './constants/issuesConfig';

const { Text, Paragraph } = Typography;

const renderValue = (value) => {
  if (value == null || (typeof value === 'string' && value.trim() === '')) {
    return <Text type='secondary' italic>No disponible</Text>;
  }

  if (typeof value === 'object') {
    return <pre style={{ margin: 0 }}>{JSON.stringify(value, null, 2)}</pre>;
  }

  return value;
};

export const InconsistenciesAlert = ({ items }) => {
  const [hovered, setHovered] = useState(false);
  const { modal } = App.useApp();

  if (!items?.length) return null; // Si no hay inconsistencias, no se muestra la alerta

  const { icon, color } = issuesConfig.inconsistency;

  const showInconsistenciesModal = () => {
    modal.confirm({
      icon: null,
      title: (
        <Space>
          <Text style={{ color: color }}>
            {icon}
          </Text>
          Inconsistencias
          <Tag color={color}>{items.length}</Tag>
        </Space>
      ),
      content: (
        < List
          split={false}
          dataSource={items}
          renderItem={({ field, sent_value: sentValue, received_value: receivedValue, info_message: infoMessage }) => (
            <List.Item>
              <Card
                title={<Text>Campo: {field}</Text>}
                style={{ width: '100%' }}
              >
                <Space direction='vertical' size={4}>
                  <Text>Valor enviado: {renderValue(sentValue)}</Text>
                  <Text>Valor recibido: {renderValue(receivedValue)}</Text>
                  {infoMessage && ( // El fontSize se aplica en un <span> para que la propiedad se respete dentro del tooltip de ellipsis
                    <Paragraph
                      type='secondary'
                      italic
                      ellipsis={{ rows: 2, tooltip: true }}
                      style={{ margin: 0 }}
                    >
                      <span style={{ fontSize: '0.9rem' }}>*{infoMessage}</span>
                    </Paragraph>
                  )}
                </Space>
              </Card>
            </List.Item>
          )}
        />
      ),
      maskClosable: true,
      cancelText: 'Cerrar',
      footer: (_, { CancelBtn }) => <CancelBtn />,
    })
  }

  return (
    <Alert
      showIcon
      icon={
        <Text style={{ color: color, margin: 0, paddingTop: 4 }}>
          {icon}
        </Text>
      }
      message={<Text>{items.length} inconsistencias detectadas</Text>}
      action={<FontAwesomeIcon icon={faEye} color={color} style={{ filter: hovered ? 'brightness(1.2)' : 'none' }} />}
      style={{
        textAlign: 'left',
        alignItems: 'start',
        cursor: 'pointer',
        gap: 8,
        backgroundColor: `${color}0d`, borderColor: `${color}33`,
        width: '100%',
      }}
      onClick={showInconsistenciesModal}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    />
  )
}
